var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V16.8031H0V0Z",
    fill: "#D6D4D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.208252 0.204727H8.40515V16.5977H0.208252V0.204727Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40454 0.203918H24.7962V16.597H8.40454V0.203918Z",
    fill: "#02411D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6868 10.0464C20.6768 10.0394 20.6634 10.0407 20.655 10.0493C20.5829 10.1227 20.5216 10.1806 20.4616 10.2342C19.7508 10.8668 18.8345 11.2155 17.8836 11.2155C16.7746 11.2155 15.7154 10.7404 14.9785 9.91166C14.2903 9.13582 13.9436 8.13912 14.0051 7.10274C14.0659 6.06781 14.526 5.11827 15.3019 4.42927C15.362 4.37563 15.4275 4.32128 15.5095 4.25774C15.5193 4.25072 15.5225 4.23722 15.5165 4.22669C15.5109 4.21544 15.4983 4.21049 15.487 4.214C13.7015 4.78439 12.5031 6.4258 12.5031 8.30012C12.5031 10.6658 14.4268 12.5895 16.7923 12.5895C18.4675 12.5895 20.0002 11.6033 20.6964 10.0779C20.7002 10.0661 20.6973 10.0534 20.6868 10.0464Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2239 6.75311L18.2151 6.96991L18.3147 7.9801C18.3161 7.99072 18.3239 7.9999 18.3345 8.00197C18.336 8.00269 18.338 8.00269 18.3401 8.00269C18.3486 8.00269 18.3571 7.99774 18.3611 7.99072L18.8744 7.11534L19.8648 7.33205C19.8676 7.33277 19.8692 7.33277 19.8705 7.33277H19.872C19.8862 7.33277 19.8974 7.32152 19.8974 7.30739C19.8974 7.29893 19.8917 7.29047 19.8862 7.28624L19.2155 6.53226L19.7287 5.65761C19.7343 5.64771 19.733 5.63646 19.7259 5.62791C19.7181 5.61945 19.7068 5.61729 19.6971 5.62152L18.7673 6.0282L18.0932 5.27072C18.0862 5.26226 18.0749 5.25947 18.065 5.26361C18.0546 5.26784 18.0481 5.27918 18.0496 5.28908L18.1489 6.29855L17.2191 6.70523C17.2095 6.71018 17.2036 6.72008 17.2052 6.73133C17.2057 6.74186 17.2133 6.75104 17.2239 6.75311Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF6);
export default __webpack_public_path__ + "static/media/f6.0a80888e3a28d5c2b203dfc991d7c5d7.svg";
export { ForwardRef as ReactComponent };